import React, { useState, useEffect } from "react";
import Header from "../nav/Header";
import ReactPaginate from 'react-paginate';
import {
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  CardActions,
  CardImage,
  CardSubtitle,
} from "@progress/kendo-react-layout";

function Facilities() {
  const [data, setData] = useState([]);
  const [pageNumber, setPageNumber] = useState(0);

  const itemsPerPage = 3;
  const pagesVisited = pageNumber * itemsPerPage;

  useEffect(() => {
    const getData = async () => {
      const dataFromServer = await fetchData();
      setData(dataFromServer);
    };
    getData();
  }, []);

  //Fetch Guides from API
  const fetchData = async () => {
    const res = await fetch("https://saraiapp.com/api/allfacilities");
    const data = await res.json();
    //console.warn(data)
    return data.slice(0,24);
  };
  
  const displayItems = data
  .slice(pagesVisited, pagesVisited + itemsPerPage)
  .map(item => {
      return(
          <div className="col-4 mb-3" key={item.id}>
              <Card>
                <CardImage
                  src={"https://saraiapp.com/" + item.media}
                  alt={item.businessName}
                />
                <div>
                  <CardHeader>
                    <CardTitle>{item.businessName}</CardTitle>
                    <CardSubtitle>
                      <span className="reviews">
                        <span
                          className="k-icon k-i-star"
                          style={{
                            color: "#ffce2a",
                          }}
                        />
                        <span
                          className="k-icon k-i-star"
                          style={{
                            color: "#ffce2a",
                          }}
                        />
                        <span
                          className="k-icon k-i-star"
                          style={{
                            color: "#ffce2a",
                          }}
                        />
                        <span
                          className="k-icon k-i-star"
                          style={{
                            color: "#ffce2a",
                          }}
                        />
                        <span className="k-icon k-i-star-outline" />
                        {/*<div>4/5 (681)</div>*/}
                      </span>
                    </CardSubtitle>
                  </CardHeader>
                  <CardBody>
                    <p>
                      <strong>About: </strong>
                      {truncate(item.about)}
                    </p>
                    <p><strong>Location: </strong> {item.city +' '+ item.country}</p>
                    <p><strong>Phone: </strong> {item.phoneOne}</p>
                  </CardBody>
                </div>
              </Card>
            </div>
      )
  })

  const pageCount = Math.ceil(data.length / itemsPerPage);

  const changePage = ({selected}) => {
      setPageNumber(selected);
  }

  //data from DB comes with HTML tags, use this to remove it
  const replaceTags = /(<([^>]+)>)/gi;

  //truncate text
  function truncate(str) {
    return str.length > 10 ? str.substring(0, 100) + "..." : str;
  }

  return (
    <React.Fragment>
      <Header />
      <div className="container mt-5">
        <div className="row">
          <div className="col-12">
            <h1 className="welcome mb-0">Medical Facilities</h1>
            <h2 className="sub-header mt-0">
              Find listed Pharmacies, Hospitals, Bloodbanks and Labs
            </h2>
          </div>
        </div>
        <div className="row">
          {displayItems}
        </div>
        <div className="row mt-5">
          <div className="col-12">
            <ReactPaginate 
            previousLabel={"Back"} 
            nextLabel={"Forward"} 
            pageCount={pageCount}
            onPageChange={changePage}
            containerClassName={"paginationBttns"}
            previousLinkClassName={"previousBttn"}
            nextLinkClassName={"nextBttn"}
            disabledClassName={"paginationDisabled"}
            activeClassName={"paginationActive"}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default Facilities;
